import { Navigate, useLocation } from 'react-router-dom';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../locales/languages';

const LanguageRedirect = () => {
  const location = useLocation();

  const browserLang = (navigator.language || '').split('-')[0].toLowerCase();
  const lang = SUPPORTED_LANGUAGES.includes(browserLang) ? browserLang : DEFAULT_LANGUAGE;

  const remainingPath = location.pathname === '/' ? '' : location.pathname;
  return <Navigate to={`/${lang}${remainingPath}${location.search}`} replace />;
};

export default LanguageRedirect;
